import { Link } from 'react-router-dom';
import { ReactComponent as Phone } from '../svgs/phone.svg';
import { ReactComponent as Search } from '../svgs/search.svg';
import { ReactComponent as Facebook } from '../svgs/facebook.svg';
import { ReactComponent as Twitter } from '../svgs/twitter.svg';
import { ReactComponent as Instagram } from '../svgs/instagram.svg';
import { ReactComponent as Youtube } from '../svgs/youtube.svg';
import { ReactComponent as Whatsapp } from '../svgs/whatsapp.svg';
import { Skeleton } from "@material-ui/lab";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getHeader } from "../redux/HeaderSlice";
import { useParams } from 'react-router-dom';
import axios from "axios";
import apiUrl from "../global.js"


function Header() {


  const [openSearch, setOpenSearch] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const toggleSearch = () => {
    setOpenSearch(!openSearch);
    setSearchValue('');
    setSearchResults([]);
  }
  const searchHandler = async (e) => {
    setSearchValue(e.target.value);

    const key = e.target.value;
    if (key.replaceAll(/\s/g, '') == '') {
      setSearchResults([]);
      return;
    }

    const response = await axios.get(
      apiUrl(`search?key=${key}`)
    );
    const data = await response.data;
    setSearchResults(data);

  };

  // If click on 1st item in menu
  const [hovered, setToggleClass] = useState(false);
  const dotoggleClass = () => {
    setToggleClass(!hovered);
    if (hovered2 === true || hovered3 === true) {
      setToggleClass2(false);
      setToggleClass3(false);
    }
  };

  // If click on 2nd item in menu
  const [hovered2, setToggleClass2] = useState(false);
  const dotoggleClass2 = () => {
    setToggleClass2(!hovered2);
    if (hovered === true || hovered3 === true) {
      setToggleClass(false);
      setToggleClass3(false);
    }
  };

  // If click on 3rd item in menu
  const [hovered3, setToggleClass3] = useState(false);
  const dotoggleClass3 = () => {
    setToggleClass3(!hovered3);
    if (hovered === true || hovered2 === true) {
      setToggleClass(false);
      setToggleClass2(false);
    }
  };

  // If click on toggle bar in mobile
  const [NavbarTogglehovered, setNavbarToggle] = useState(false);
  const doNavbarToggle = () => {
    setNavbarToggle(!NavbarTogglehovered);
    setSearchValue('');
    setSearchResults([]);
    setOpenSearch(false);
  };

  // If click link inside subMenu
  const HidesubMenu = () => {
    if (hovered === true) {
      setToggleClass(false);
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }

  // If click link inside submenuSmall
  const HidesubmenuSmall = () => {
    if (hovered2 === true || hovered3 === true) {
      setToggleClass2(false);
      setToggleClass3(false);
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };
  };

  const [Gototop, setScrollTop] = useState(false);
  const doScrollTop = () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  };

  const [closeMenu, setcloseMenu] = useState(false);
  const CloseMobileMenu = () => {
    setNavbarToggle(false);
  };

  // Fetching State
  const dispatch = useDispatch();
  const { header } = useSelector((state) => state.HeaderData);
  const { status } = useSelector((state) => state.HeaderData);
  const params = useParams();
  useEffect(() => {

      ////Passing page ID reference
      if (status !== "success") {
        dispatch(getHeader({ params }));
      }
      }, [dispatch]);
  
      if (status === "loading") {
        return (
          <header id="Header" className='Header site-header show'>
          </header>
        );
      }
  
      if (status === "success") {
        // console.log(header);
    }

  return (

    <header id="Header" className={
      hovered ? 'Header site-header change_header' :
        NavbarTogglehovered ? 'Header site-header change_header' : closeMenu ? 'Header site-header' : 'Header site-header show'
    }>
      {status === 'success' &&
        <>
          <div className="w-100">
            <div className="row justify-content-between align-items-center mobileMenuPadding">
              <div className="col-3 col-xl-2 col-lg-2 col-md-2 col-sm-2 text-left">
                <Link onClick={doScrollTop} className="navbar-brand mr-0" to="/">
                  <img CloseMobileMenu={CloseMobileMenu} className="p-0 headerColorLogo" src={header.header_logo.url ? header.header_logo.url : null} alt={header.header_logo.alt}></img>
                </Link>
              </div>
              <div className="d-none col-xl-6 col-lg-7 col-md-8 col-sm-10 mt-0 mt-sm-0 align-items-center justify-content-center d-md-flex">
                <div className="d-none d-md-flex">
                  <div className="menu-primary-container">
                    <ul id="menu-primary" className="navbar-nav">
                      {header.header_menu ? header.header_menu.map((el, i) => {
                        return <li key={i} id={"menu-item-" + i} className=""><Link to={el.link.url}>{el.link.title}</Link></li>
                      }) : null}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-2 col-sm-1 col-md-2 col-lg-2 col-xl-2 d-flex justify-content-end">
                <button onClick={doNavbarToggle} className={NavbarTogglehovered ? 'navbar-toggler navbar-open d-inline-block d-md-none' : 'navbar-toggler d-inline-block d-md-none'} type="button" data-toggle="collapse" data-target="#mobileMenu" aria-controls="mobileMenu" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div className="d-none d-md-flex header_right pt-2 pb-2 justify-content-end">
                  <a href={"tel:" + header.phone_number}><Phone /></a>
                  <Link to="#" onClick={toggleSearch}><Search /></Link>
                </div>
              </div>
            </div>
          </div>
          <div class="row search-bar" className={openSearch ? "row search-bar open-search" : "row search-bar"}>
            <div class="col-xl-5 col-sm-7">
              <span class="search-icon">
                <label for="searchInput">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                    <path fill="#ccc" d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                  </svg>
                </label>
              </span>
              <input onChange={searchHandler} value={searchValue} id="searchInput" type="text" placeholder="Search here..." class="search-input" />
              <span class="clear-search-icon" onClick={toggleSearch}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                  <path fill="#ccc" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </span>
            </div>
          </div>
          <div className="mobileHeader" style={{ display: `none` }}>
            <div className="row navbarToggle" style={{ animationDelay: `300ms` }}>
              <div className="col-6">
                <button onClick={doNavbarToggle} className={NavbarTogglehovered ? 'navbar-toggler navbar-open d-inline-block d-md-none' : 'navbar-toggler d-inline-block d-md-none'} type="button" data-toggle="collapse" data-target="#mobileMenu" aria-controls="mobileMenu" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button>
              </div>
              <div className="col-6 phoneLinkMobile" style={{ animationDelay: `500ms` }}>
                <a href={"tel:" + header.phone_number}><Phone /></a>
              </div>
            </div>
            <div className="searchBarMobile mt-5" style={{ animationDelay: `700ms` }}>
              <input onChange={searchHandler} value={searchValue} type="text" placeholder="Search..."></input>
            </div>
            <div class="mobile-search-results" hidden={searchValue?.replaceAll(/\s/g, '') === ''}>
              <h3 class="portfolio-results">Portfolios</h3>
              <div class="portfolio-results-grid mobile">
                {
                  searchResults.portfolio ? searchResults.portfolio.map(
                    (portfolio) => {
                      return <div class="portfolio-result">
                        <img src={portfolio.thumbnail} />
                        <p>
                          <h5 class="portfolio-result-title"> &nbsp; {portfolio.post_title.toLowerCase()}</h5>
                          <h6 class="portfolio-result-location"> &nbsp; {portfolio.location.toLowerCase()}</h6>
                        </p>
                        <a class="portfolio-search-link" href={"portfolio/" + portfolio.post_name} ></a>
                      </div>
                    }
                  ) : <h4>No results</h4>
                }
              </div>

              <hr class="seperator" />

              <div class="results-grid mobile">
                <div class="result-col">
                  <h3 class="results-title">Kitchen</h3>
                  <ul class="results-list">
                    {
                      searchResults.kitchen && searchResults.kitchen.length !== 0 ? searchResults.kitchen.map((kitchen) =>
                        <li>
                          <a href={"kitchen/" + kitchen.post_name}> {kitchen.post_title}
                          </a>
                        </li>)
                        : <li>no results</li>
                    }
                  </ul>
                </div>
                { <div class="result-col">
                  <h3 class="results-title">Wardrobe</h3>
                  <ul class="results-list">
                    {
                      searchResults.wardrobe && searchResults.wardrobe.length !== 0 ? searchResults.wardrobe.map((wardrobe) =>
                        <li> <a href="wardrobes"> {wardrobe.post_title} </a> </li>)
                        : <li>no results</li>
                    }
                  </ul>
                </div> }
                <div class="result-col">
                  <h3 class="results-title">Blog</h3>
                  <ul class="results-list">
                    {
                      searchResults.post && searchResults.post.length !== 0 ? searchResults.post.map((post) =>
                        <li>
                          <a href={"blog/" + post.post_name}> {post.post_title}
                          </a> </li>)

                        : <li>no results</li>
                    }
                  </ul>
                </div>
              </div>

            </div>
            <div id="mobileMenu" className={NavbarTogglehovered ? 'collapse navbar-collapse mobile-menu-opened justify-content-between position-relative mt-4' : 'collapse navbar-collapse justify-content-between position-relative mt-4'} style={{ animationDelay: `900ms` }} hidden={searchValue?.replaceAll(/\s/g, '') !== ''}>
              <nav className="navbar navbar-expand-sm">
                <div className="menu-primary-container">
                  <ul id="menu-primary" className="navbar-nav">
                    {header.header_menu ? header.header_menu.map((el, i) => {
                      return <li key={i} id={"menu-item-" + i} className=""><Link to={el.link.url} onClick={doNavbarToggle}>{el.link.title}</Link></li>
                    }) : null}
                  </ul>
                </div>
              </nav>
            </div>
            <div hidden={searchValue?.replaceAll(/\s/g, '') !== ''} className="HeaderSocialIcons" style={{ animationDelay: `1.1s` }}>
              <div className="row align-items-center">
                <div className="col-9">
                  {header.social_icons ? header.social_icons.map((el, i) => {
                    return <a target="_blank" key={i} href={el.link} dangerouslySetInnerHTML={{__html: el.icon}} ></a>
                  }) : null}
                </div>
                <div className="col-3 WhatsappHeader text-end">
                  <a href={"https://wa.me/" + header.whatsapp_number} target="_blank"><Whatsapp /></a>
                </div>
              </div>
            </div>
          </div>
          <div className={openSearch ? "search-results open-results" : "search-results"}>
            <h2 class="results-number">   {searchValue?.replaceAll(/\s/g, '') === '' ? 'Enter search term' : `Showing ${searchResults.numberOfResults || 0} results`}</h2>

            {searchValue?.replaceAll(/\s/g, '') !== '' ? <span>
              <h3 class="portfolio-results">Portfolios</h3>
              <div class="portfolio-results-grid">
                {
                  searchResults.portfolio ? searchResults.portfolio.map(
                    (portfolio) => {
                      return <div class="portfolio-result">
                        <img src={portfolio.thumbnail} />
                        <p>
                          <h5 class="portfolio-result-title"> &nbsp; {portfolio.post_title}</h5>
                          <h6 class="portfolio-result-location"> &nbsp; {portfolio.location}</h6>
                        </p>
                        <a class="portfolio-search-link" href={"portfolio/" + portfolio.post_name} ></a>
                      </div>
                    }
                  ) : <h4>No results</h4>
                }
              </div>

              <hr class="seperator" />

              <div class="results-grid">
                <div class="result-col">
                  <h3 class="results-title">Kitchen</h3>
                  <ul class="results-list">
                    {
                      searchResults.kitchen && searchResults.kitchen.length !== 0 ? searchResults.kitchen.map((kitchen) =>
                        <li>
                          <a href={"kitchen/" + kitchen.post_name}> {kitchen.post_title}
                          </a>
                        </li>)
                        : <li>no results</li>
                    }
                  </ul>
                </div>
                <div class="result-col">
                  <h3 class="results-title">Wardrobe</h3>
                  <ul class="results-list">
                    {
                      searchResults.wardrobe && searchResults.wardrobe.length !== 0 ? searchResults.wardrobe.map((wardrobe) =>
                      <li> <a href="wardrobes"> {wardrobe.post_title} </a> </li>)
                        : <li>no results</li>
                    }
                  </ul>
                </div>
                <div class="result-col">
                  <h3 class="results-title">Blog</h3>
                  <ul class="results-list">
                    {
                      searchResults.post && searchResults.post.length !== 0 ? searchResults.post.map((post) =>
                        <li>
                          <a href={"blog/" + post.post_name}> {post.post_title}
                          </a> </li>)

                        : <li>no results</li>
                    }
                  </ul>
                </div>
              </div>
            </span> : null}
          </div>
        </>}
    </header>
  );
};
export default Header;